export const getTrustYouProfilesFromResponse = response => response.response;

export const getTrustYouReviewsFromResponse = response => (
    response.response.category_list.reduce((acc, review) => (
        [
            ...acc,
            {
                stars   : Math.floor(review.score / 20),
                content : [
                    review.short_text,
                    ...(review.highlight_list.map(item => item.text)),
                ],
            },
        ]
    ), [])
);

export const getTrustYouProfileById = (id, trustYouReducer) => id && trustYouReducer[id]?.profile?.data;
export const getTrustYouProfileLanguageById = (id, trustYouReducer) => id && trustYouReducer[id]?.profile?.language;
export const getTrustYouReviewsById = (id, trustYouReducer) => id && trustYouReducer[id]?.reviews?.data;
